/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useCallback, useEffect, useState } from "react";
import PackageInstanceItem from "./PackageInstanceItem";
import PackageInstanceSection from "./PackageInstanceSection";
import { usePackageInstances } from "../../../lib/react-query/usePackages";

const InvoicePackageInstances = ({ invoice }) => {
  const instances = invoice?.package_instances;
  const [openIds, setOpenIds] = useState({});

  const { data: freshData, hasNextPage, fetchNextPage } = usePackageInstances(invoice?.id, {
    enabled: !!invoice?.id && !!instances?.length,
  });

  const freshInstancesMap = (freshData?.pages?.flatMap(p => p.data) ?? [])
    .reduce((acc, inst) => { acc[inst.id] = inst; return acc; }, {});

  const allNeededLoaded = instances?.every(inst => !!freshInstancesMap[inst.id]);

  useEffect(() => {
    if (hasNextPage && !allNeededLoaded) fetchNextPage();
  }, [hasNextPage, allNeededLoaded, fetchNextPage]);

  const toggleOpen = useCallback((id) => {
    setOpenIds((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);

  if (!instances?.length) return null;

  return (
    <PackageInstanceSection readOnly>
      {instances.map((instance) => (
        <PackageInstanceItem
          key={instance.id}
          item={freshInstancesMap[instance.id] ?? instance}
          isSelected={instance}
          isOpen={!!openIds[instance.id]}
          onToggle={() => toggleOpen(instance.id)}
          readOnly
        />
      ))}
    </PackageInstanceSection>
  );
};

export default InvoicePackageInstances;